import React from 'react'
import PropTypes from 'prop-types'

import { ClockIcon, Delivery, Restoran, Table, Edit, Arrow } from './Svg'
import { DINE_IN_ENABLED } from '../featureFlags'

class Main extends React.Component {
  // Функция для проверки, открыт ли ресторан в текущее время
  isRestaurantOpen = (worktime) => {
    if (!worktime) return false
    
    try {
      const [openTime, closeTime] = worktime.split('-')
      const [openHours, openMinutes] = openTime.split(':').map(Number)
      const [closeHours, closeMinutes] = closeTime.split(':').map(Number)
      
      const now = new Date()
      const currentHours = now.getHours()
      const currentMinutes = now.getMinutes()
      
      const currentTotalMinutes = currentHours * 60 + currentMinutes
      const openTotalMinutes = openHours * 60 + openMinutes
      const closeTotalMinutes = closeHours * 60 + closeMinutes
      
      return currentTotalMinutes >= openTotalMinutes && currentTotalMinutes <= closeTotalMinutes
    } catch (error) {
      console.error('Error parsing worktime:', error)
      return false
    }
  }

  handleDeliveryTypeChange = (type) => {
    // Задержка для анимации перед фактическим изменением
    setTimeout(() => {
      this.props.changeDeliveryType(type)
    }, 150)
  }

  render() {
    const { user, restaurant, showLocation, showUsloviyaWin } = this.props
    const isOpen = restaurant?.worktime ? this.isRestaurantOpen(restaurant.worktime) : false
    const delivery = user?.delivery_type == `delivery`
    const dineInAvailable = DINE_IN_ENABLED && !!restaurant?.dine_in_available
    const dineIn = user?.delivery_type == `dine_in` && dineInAvailable

    const tabs = dineInAvailable
      ? [
          { type: 'delivery', title: 'Доставка', icon: <Delivery /> },
          { type: 'pickup', title: 'Самовывоз', icon: <Restoran /> },
          { type: 'dine_in', title: 'В зале', icon: <Table /> }
        ]
      : [
          { type: 'delivery', title: 'Доставка', icon: <Delivery /> },
          { type: 'pickup', title: 'Самовывоз', icon: <Restoran /> }
        ]

    const activeType = delivery ? 'delivery' : (dineIn && dineInAvailable ? 'dine_in' : 'pickup')
    const activeIndex = Math.max(tabs.findIndex(tab => tab.type === activeType), 0)
    const tabWidth = 100 / tabs.length

    return (
      <div className='mt-[8px] bg-white rounded-[25px] p-[10px]'>
        {/* Переключатель способа получения */}
        <div className='w-100 h-[40px] bg-[#F6F6F6] flex items-center justify-between rounded-full relative'>
          {/* Фоновая плашка, которая перемещается */}
          <div
            className='absolute h-[40px] bg-[#5A91FF] rounded-full transition-all duration-300 ease-in-out'
            style={{ width: `${tabWidth}%`, left: `${activeIndex * tabWidth}%` }}
          />

          {tabs.map(tab => {
            const active = tab.type === activeType

            return (
              <div
                key={tab.type}
                onClick={() => !active && this.handleDeliveryTypeChange(tab.type)}
                className={`h-[40px] flex-1 flex items-center justify-center gap-[4px] font-[14px] rounded-full relative z-10 cursor-pointer transition-all duration-300 ${
                  active ? 'text-white' : 'text-dark'
                }`}
              >
                <div className={`flex-none transition-transform duration-300 ${active ? 'scale-110' : 'scale-100'}`}>
                  {tab.icon}
                </div>
                <div className={`transition-all duration-300 ${active ? 'font-semibold' : ''}`}>
                  {tab.title}
                </div>
              </div>
            )
          })}
        </div>

        {/* Адресная секция с плавным переходом */}
        <div className="relative overflow-hidden">
          {/* Контент для доставки */}
          <div 
            className={`transition-all duration-300 ease-in-out ${
              delivery 
                ? 'opacity-100 translate-y-0' 
                : 'opacity-0 -translate-y-full absolute top-0 left-0 w-full'
            }`}
            style={{ 
              height: delivery ? 'auto' : '0',
              pointerEvents: delivery ? 'auto' : 'none'
            }}
          >
            <div className='text-[14px] text-[#00000099] mt-[10px]'>Адрес доставки</div>
            <div onClick={() => showLocation()} className='flex items-center justify-between gap-[5px]'>
              <div className='text-[16px] font-semibold text-black'>{user?.location?.address || `Укажите ваш адрес!`}</div>
              <div className="flex-none w-[30px] h-[30px] rounded-full bg-[#F6F6F6] flex items-center justify-center cursor-pointer hover:bg-[#E0E0E0] transition-colors duration-200">
                <Edit />
              </div>
            </div>
            <div className='w-100 h-[30px] mt-[5px] bg-[#F6F6F6] rounded-full flex items-center justify-between text-[14px] text-[#00000099] px-[15px]'>
              <div className='flex items-center gap-[6px]'>
                <ClockIcon />
                <div>Доставим на адрес</div>
              </div>
              <div className='flex items-center gap-[5px]'>
                <div>
                  от <span className='text-black'>{user?.location?.sum_min} ₽</span>
                  {user?.location?.time != `` && <> за <span className='text-black'>{user?.location?.time} мин</span></>}
                </div>
                <div onClick={() => showUsloviyaWin()} className='cursor-pointer ml-1 hover:scale-110 transition-transform duration-200'>
                  <Arrow />
                </div>
              </div>
            </div>
          </div>

          {/* Контент для самовывоза и заказа в зале */}
          <div 
            className={`transition-all duration-300 ease-in-out ${
              !delivery 
                ? 'opacity-100 translate-y-0' 
                : 'opacity-0 translate-y-full absolute top-0 left-0 w-full'
            }`}
            style={{ 
              height: !delivery ? 'auto' : '0',
              pointerEvents: !delivery ? 'auto' : 'none'
            }}
          >
            <div className='text-[14px] text-[#00000099] mt-[10px]'>{dineIn ? `Заказ подадим в зале` : `Где заберете заказ?`}</div>
            <div onClick={() => showLocation()} className='flex items-center justify-between gap-[5px]'>
              <div className='text-[16px] font-semibold text-black'>{restaurant?.adres || `Укажите ваш адрес!`}</div>
              <div className="flex-none w-[30px] h-[30px] rounded-full bg-[#F6F6F6] flex items-center justify-center cursor-pointer hover:bg-[#E0E0E0] transition-colors duration-200">
                <Edit />
              </div>
            </div>
            <div className='flex items-center gap-[6px] mt-[5px] mb-[10px]'>
              {isOpen ? (
                <div className='bg-[#A6DD2F] text-white text-[12px] flex items-center h-[20px] px-[8px] rounded-full transition-all duration-300 hover:scale-105'>
                  открыто
                </div>
              ) : (
                <div className='bg-[#F87605] text-white text-[12px] flex items-center h-[20px] px-[8px] rounded-full transition-all duration-300 hover:scale-105'>
                  закрыто
                </div>
              )}
              <div className='text-[#00000099] text-[14px] transition-opacity duration-300'>
                {restaurant?.worktime}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  user: PropTypes.object,
  restaurant: PropTypes.object,
  showLocation: PropTypes.func,
  changeDeliveryType: PropTypes.func,
  showUsloviyaWin: PropTypes.func
}

export default Main